import React, {Component} from 'react';
import { Card, List } from 'semantic-ui-react';
import RuneInfoTable from './RuneInfoTable';

export default class RuneContent extends Component {
    render() {
        const {rune} = this.props;

        if(!rune) {
            return null;
        }

        return (
            <Card.Content>
                <List>
                    <List.Item>
                        <RuneInfoTable stats={rune.Stats} slots={rune.Slots} iLevel={rune.Level} />
                    </List.Item>
                </List>
            </Card.Content>
        )
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/runes/RuneContent.jsx